import React from 'react';
import { ShowButton } from 'react-admin';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import Journey from './Journey';
import ChartInsight from './ChartInsight';
import OptimizationInsight from './OptimizationInsight';

const defaultCardStyle = {
    width: '100%',
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};

const InsightsGrid = ({ ids, data, basePath }) => (
    <div style={{ margin: '1em' }}>
        {ids.map(id =>
            <Card key={id} style={defaultCardStyle}>
                <CardHeader title={data[id].title} />
                <CardContent>
                    {renderInsightGroup(data[id], id)}
                </CardContent>
                <CardActions style={{ textAlign: 'right' }}>
                    <ShowButton label="Analyze" resource="insights" basePath={basePath} record={data[id]} />
                </CardActions>
            </Card>
        )}
    </div>
);

InsightsGrid.defaultProps = {
    data: {},
    ids: [],
};

const renderInsightGroup = (datum, key) => {
    switch (datum.type) {
        case "ChartInsight":
            return <ChartInsight key={key} {...datum} />
        case "OptimizationInsight":
            return <OptimizationInsight key={key} {...datum} />
        case "JourneyInsight":
            return <Journey key={key} {...datum} />
        default:
            <h1>No chart found</h1>
    }
}

export default InsightsGrid;


// WEBPACK FOOTER //
// ./src/components/InsightsGrid.js